import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { StoreProvider } from 'easy-peasy';
import { CookiesProvider } from 'react-cookie';
import App from './App';
import theme from './theme';
import store from './redux/store';
import * as serviceWorker from './serviceWorker';
import 'utils/analyticsUtil';

ReactDOM.render(
	<StoreProvider store={store}>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<CookiesProvider>
				<App />
			</CookiesProvider>
		</ThemeProvider>
	</StoreProvider>,
	document.querySelector('#root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
